export const account = [
  {
    account: "pdd*****1762",
    address: "广东省广州市番禺区青蓝街**号",
    company: "圆通",
    index: 1,
    node: "番禺大学城",
    overage: 200,
  },
  {
    account: "pdd*****1762",
    address: "广东省广州市番禺区青蓝街**号",
    company: "中通",
    index: 2,
    node: "番禺大学城",
    overage: 99,
  },
  {
    account: "pdd*****1762",
    address: "广东省广州市番禺区青蓝街**号",
    company: "韵达",
    index: 3,
    node: "番禺大学城",
    overage: 87,
  },
  {
    account: "pdd*****1762",
    address: "广东省广州市番禺区青蓝街**号",
    company: "申通",
    index: 4,
    node: "番禺大学城",
    overage: 159,
  },
];
